/**
 * Wrapper around $.shopgate.ajax
 */
class NetworkGateway {
  /**
   * @param {function} ajaxLib - function that accepts params url, success,
   *                             error (like $.shopgate.ajax)
   */
  constructor(ajaxLib) {
    this.client = ajaxLib;
  }

  /**
   * Perform GET request
   *
   * @param {string} endpoint
   * @return {Promise}
   */
  get(endpoint) {
    return new Promise((resolve, reject) => {
      this.client({
        url: endpoint,
        method: 'GET',
        success: response => resolve(response),
        error: e => reject(e),
      });
    });
  }
}

export default NetworkGateway;



// WEBPACK FOOTER //
// ./Library/1.0/common/shop_settings/minimum_order_value/NetworkGateway.js